import { FormGroup, FormLabel, FormText } from 'react-bootstrap';
import Feedback from 'react-bootstrap/esm/Feedback';
import { Controller } from 'react-hook-form';
import CountrySelect from './CountrySelect';

const CountryFormInput = ({
  name,
  containerClass,
  control,
  helpText,
  id,
  label,
  noValidate,
  placeholder = 'Select country',
}) => (
  <Controller
    name={name}
    defaultValue=""
    control={control}
    render={({ field, fieldState }) => (
      <FormGroup className={containerClass ?? ''}>
        {label ? <FormLabel htmlFor={id}>{label}</FormLabel> : null}
        <CountrySelect
          id={id}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          placeholder={placeholder}
          isInvalid={Boolean(fieldState.error?.message)}
        />
        {helpText ? <FormText id={`${id}-help`}>{helpText}</FormText> : null}
        {!noValidate && fieldState.error?.message ? <Feedback type="invalid">{fieldState.error.message}</Feedback> : null}
      </FormGroup>
    )}
  />
);

export default CountryFormInput;
